(function () {
  'use strict';

  /**
   * benefits-bar-reviews.js
   *
   * Updates the Google rating block in the benefits bar with live
   * data from the same Cloudflare Worker proxy used by the Why Us
   * tab. The customizer-set rating/count remain in the markup as
   * fallback, so if the proxy is unreachable the bar still shows
   * sensible values.
   *
   * Shares the sessionStorage cache key with why-us-reviews.js so
   * the first fetch on a page populates both the bar and the Why
   * Us tab.
   */

  var CACHE_KEY = 'justtilesni_google_reviews_v1';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours, matches Worker

  function init() {
    var block = document.querySelector('[data-benefits-google-block]');
    if (!block) return;

    var proxyUrl = block.dataset.proxyUrl;
    var placeId  = block.dataset.placeId;
    if (!proxyUrl || !placeId) return;

    // Try cache first
    var cached = readCache();
    if (cached) {
      paint(block, cached);
      return;
    }

    // Fetch from proxy
    var url = proxyUrl + (proxyUrl.indexOf('?') === -1 ? '?' : '&') +
              'place_id=' + encodeURIComponent(placeId);

    fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('Proxy ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || typeof data.rating === 'undefined') return;
        writeCache(data);
        paint(block, data);
      })
      .catch(function () {
        // Silent fail - the customizer fallback values remain visible
      });
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed.timestamp || (Date.now() - parsed.timestamp) > CACHE_TTL_MS) {
        return null;
      }
      return parsed.data;
    } catch (e) { return null; }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        timestamp: Date.now(),
        data: data
      }));
    } catch (e) {}
  }

  function paint(block, data) {
    var rating = parseFloat(data.rating || 0);
    var count = parseInt(data.user_ratings_total || 0, 10);
    var subtitleSuffix = block.dataset.subtitleSuffix || 'reviews';

    var ratingEl = block.querySelector('[data-benefits-google-rating]');
    var starsEl  = block.querySelector('[data-benefits-google-stars]');
    var subEl    = block.querySelector('[data-benefits-google-subtitle]');

    if (ratingEl) ratingEl.textContent = rating.toFixed(1);
    if (starsEl)  starsEl.innerHTML = buildStars(rating);
    if (subEl && count > 0) {
      subEl.textContent = count.toLocaleString() + ' ' + subtitleSuffix;
    }
  }

  function buildStars(rating) {
    var r = Math.max(0, Math.min(5, parseFloat(rating) || 0));
    var x10 = Math.round(r * 10);
    var full = Math.floor(x10 / 10);
    var rem = x10 % 10;
    var hasHalf = (rem >= 3 && rem <= 7);
    if (rem > 7) full += 1;
    var empty = 5 - full - (hasHalf ? 1 : 0);
    if (empty < 0) empty = 0;

    var html = '';
    for (var i = 0; i < full; i++) html += '★';
    if (hasHalf) html += '<span class="benefits-bar__half-star">★</span>';
    for (var j = 0; j < empty; j++) html += '<span class="benefits-bar__empty-star">★</span>';
    return html;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
